import VueText from './VueText'
const component = {
    install: function(Vue){
        Vue.component('VueText',VueText)
    }
}
export default component